export default __webpack_public_path__ + "static/media/arrosticiniang.7a1945ca.avif";